import { Bankloading } from '@/icons/iconsComponent';
import { language } from '../model';
import { TDestination } from '../model/types';

type TContentProps = {
  destination?: TDestination;
};

export const Content = ({ destination }: TContentProps) => {
  const destinationText =
    destination === 'gateway' ? language.gateway : language.bank;

  return (
    <div className='flex flex-col items-center gap-5 justify-center py-[45px]'>
      <Bankloading />
      <div dir='ltr' className='h-1 w-[200px] bg-neutral-200 dark:bg-neutral-600 rounded-full'>
        <div className='h-1 !rounded-full bg-pics duration-2000 animate-increaseWidthBank'></div>
      </div>
      <p className='text-text text-center body-12-regular leading-[18px]'>
        {language.transferringTo(destinationText)}
        <br />
        {language.pleaseWait}
      </p>
    </div>
  );
};
